import * as angular from 'angular';
import * as _ from 'lodash';

import { serviceModule } from '../services/services.module';

import * as c from './';
import { IdentifierAnalysisService } from './identifierAnalysis/identifierAnalysis.service';

export const componentModule = 'wt-component';

const m = angular.module(componentModule, [serviceModule]);
for (const key of Object.keys(c)) {
    if (c[key].hasOwnProperty('componentId')) {
        const obj = c[key];
        m.component(obj.componentId, obj);
    }
}
m.service(IdentifierAnalysisService.serviceId, IdentifierAnalysisService);
